import React from 'react';
import { Section } from './Section';
import { Book, Clock, Brain, Shield, CalendarCheck } from 'lucide-react';
const deliverables = [{
  icon: Book,
  title: 'El Manual Maestro (PDF)',
  desc: 'La arquitectura completa para configurar tu Búnker de Enfoque.'
}, {
  icon: Clock,
  title: 'Protocolo de 180 Minutos',
  desc: 'El algoritmo exacto (Fase Alpha y Beta) para ejecutar sin distracciones.'
}, {
  icon: Brain,
  title: 'Identificador de Cronotipos',
  desc: 'Para que dejes de luchar contra tu biología y trabajes en tu pico de cortisol.'
}, {
  icon: Shield,
  title: 'Guía de Blindaje Digital',
  desc: 'Las herramientas exactas para hacer que tu teléfono sea incapaz de interrumpirte.'
}, {
  icon: CalendarCheck,
  title: 'Plantilla de Auditoría de Domingo',
  desc: '20 minutos para garantizar que el lunes entres a matar.'
}];
export function DeliverablesSection() {
  return <Section className="bg-tactical-gray border-y border-tactical-border" data-id="element-15">
      <h2 className="text-3xl md:text-5xl font-bold text-white uppercase text-center mb-10" data-id="element-16">
        Lo que <span className="text-accent" data-id="element-17">obtienes:</span>
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto" data-id="element-18">
        {deliverables.map((item, idx) => {
        const Icon = item.icon;
        return <div key={idx} className="bg-tactical-dark border border-tactical-border hover:border-accent/50 transition-colors p-8 flex flex-col items-center text-center group" data-id="element-19">
              <div className="bg-tactical-light p-4 border border-tactical-border group-hover:border-accent/30 mb-6 transition-colors" data-id="element-20">
                <Icon className="w-8 h-8 text-accent" data-id="element-21" />
              </div>
              <h3 className="text-xl font-oswald text-white uppercase mb-3" data-id="element-22">
                {item.title}
              </h3>
              <p className="text-zinc-400 leading-relaxed" data-id="element-23">{item.desc}</p>
            </div>;
      })}
      </div>
    </Section>;
}